import PrecallSurvey from '@components/pages/account/survey/PrecallSurvey';
import { AEP_SurveyStep } from '@components/pages/account/survey/PrecallSurvey/constants';

export const PrecallAepSoa = () => <PrecallSurvey step={AEP_SurveyStep.CALENDLY} />;

export default PrecallAepSoa;
